// extracted by mini-css-extract-plugin
module.exports = {"modal-scroll":"TooltipText_modal-scroll__Ee2BQ","tooltipText":"TooltipText_tooltipText__DeSdu"};